// extracted by mini-css-extract-plugin
export default {"loadText":"Loading_loadText__GpV4N","loader":"Loading_loader__rS1ky","loaderAnimation":"Loading_loaderAnimation__D41wz"};